var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.23559 6L3.56059 2.325C3.43559 2.2 3.37509 2.052 3.37909 1.881C3.38309 1.71 3.44776 1.56217 3.57309 1.4375C3.69809 1.3125 3.84609 1.25 4.01709 1.25C4.18809 1.25 4.33593 1.3125 4.46059 1.4375L8.29809 5.2875C8.39809 5.3875 8.47309 5.5 8.52309 5.625C8.57309 5.75 8.59809 5.875 8.59809 6C8.59809 6.125 8.57309 6.25 8.52309 6.375C8.47309 6.5 8.39809 6.6125 8.29809 6.7125L4.44809 10.5625C4.32309 10.6875 4.17726 10.748 4.01059 10.744C3.84393 10.74 3.69809 10.6753 3.57309 10.55C3.44809 10.425 3.38559 10.277 3.38559 10.106C3.38559 9.935 3.44809 9.78717 3.57309 9.6625L7.23559 6Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.75783675d9ffb4770c7d09e07cd7d8f7.svg";
export { ForwardRef as ReactComponent };